<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194.461"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M66.121 70.509c6.571,22.013 7.05,46.367 1.438,73.063 11.65,-35.358 12.728,-60.114 3.233,-74.267 -1.187,0.376 -2.483,0.603 -4.671,1.204z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M42.152 74.225c-10.492,18.299 -15.45,39.919 -14.874,64.861 -4.893,-33.888 -1.385,-56.181 10.522,-66.88 1.093,0.576 2.32,1.041 4.352,2.019z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M92.117 46.938c-0.455,2.547 -1.151,5.076 -1.829,7.012 -0.04,0.114 -0.079,0.225 -0.119,0.334 -0.021,-0.2 -0.042,-0.399 -0.064,-0.599 -8.346,-5.044 -16.812,-8.595 -25.399,-10.654 3.995,-8.233 3.814,-17.312 -0.545,-26.023 5.764,-1.489 11.608,-3.863 17.534,-7.12 2.243,1.294 4.209,3.217 5.897,5.781 1.688,2.565 3.099,5.771 3.954,9.81 0.855,4.038 1.154,8.911 1.197,12.629 0.042,3.719 -0.171,6.283 -0.626,8.83z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M64.161 17.008c-7.712,1.993 -15.281,2.403 -22.705,1.23 -7.019,-1.108 -13.909,-3.631 -20.67,-7.568 0.657,-0.554 1.339,-1.024 2.042,-1.386 2.158,-1.111 4.509,-1.196 6.651,-1.293 2.142,-0.096 4.074,-0.203 6.083,-0.053 2.009,0.149 4.094,0.556 5.627,1.079 1.534,0.523 2.517,1.164 5.065,1.413 2.549,0.249 6.664,0.105 9.876,-0.128 3.212,-0.233 5.519,-0.555 6.994,-1.058 1.474,-0.503 2.116,-1.187 3.857,-1.547 1.741,-0.359 4.584,-0.395 7.266,-0.081 2.681,0.315 5.204,0.978 7.448,2.272 -5.926,3.257 -11.77,5.631 -17.534,7.12z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M39.268 41.264c-0.352,-6.882 0.377,-14.557 2.188,-23.026 7.424,1.173 14.993,0.763 22.705,-1.23 4.359,8.711 4.54,17.79 0.545,26.023 -8.365,-2.006 -16.844,-2.595 -25.438,-1.767z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M41.456 18.238c-1.811,8.469 -2.54,16.144 -2.188,23.026 -7.786,0.749 -15.666,2.662 -23.64,5.737 -0.932,-1.991 -1.679,-4.119 -2.127,-6.43 -0.607,-3.129 -0.667,-6.595 -0.699,-9.6 -0.032,-3.005 -0.036,-5.551 0.625,-8.191 0.661,-2.641 1.986,-5.375 3.632,-7.812 1.109,-1.644 2.365,-3.15 3.727,-4.298 6.761,3.937 13.651,6.46 20.67,7.568z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M39.268 41.264c8.594,-0.828 17.073,-0.239 25.438,1.767 8.587,2.059 17.053,5.61 25.399,10.654 0.022,0.2 0.043,0.399 0.064,0.599 -0.648,1.755 -1.451,2.955 -5.147,3.132 -3.926,0.189 -11.117,-0.777 -17.688,-1.033 -6.572,-0.257 -12.524,0.196 -17.38,0.411 -4.856,0.216 -8.617,0.195 -13.18,0.08 -4.563,-0.115 -9.928,-0.325 -13.454,-1.605 -2.37,-0.859 -3.91,-2.203 -5.096,-3.772 -0.579,-0.767 -1.074,-1.587 -1.541,-2.43 -0.371,-0.673 -0.725,-1.361 -1.055,-2.066 7.974,-3.075 15.854,-4.988 23.64,-5.737z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M90.167 54.287c3.011,29.125 -2.424,61.414 -16.308,96.866 -6.027,12.23 -13.394,13.728 -14.296,4.423 -1.697,-17.495 1.455,-34.072 -0.706,-55.645 -1.518,-15.163 -7.645,-18.135 -12.821,-8.399 -5.403,10.161 -6.184,26.728 -9.168,48.788 -2.188,16.175 -14.512,15.402 -16.462,2.774 -3.062,-19.838 -3.25,-53.108 -2.179,-91.594m-4.8 -28.72c0.661,-2.641 1.986,-5.375 3.632,-7.812 1.645,-2.436 3.61,-4.573 5.769,-5.684 2.158,-1.111 4.509,-1.196 6.651,-1.293 2.142,-0.096 4.074,-0.203 6.083,-0.053 2.009,0.149 4.094,0.556 5.627,1.079 1.534,0.523 2.517,1.164 5.065,1.413 2.549,0.249 6.664,0.105 9.876,-0.128 3.212,-0.233 5.519,-0.555 6.994,-1.058 1.474,-0.503 2.116,-1.187 3.857,-1.547 1.741,-0.359 4.584,-0.395 7.266,-0.081 2.681,0.315 5.204,0.978 7.448,2.272 2.243,1.294 4.209,3.217 5.897,5.781 1.688,2.565 3.099,5.771 3.954,9.81 0.855,4.038 1.154,8.911 1.197,12.629 0.042,3.719 -0.171,6.283 -0.626,8.83 -0.455,2.547 -1.151,5.076 -1.829,7.012l-0.121 0.337c-0.647,1.754 -1.451,2.952 -5.145,3.129 -3.926,0.189 -11.117,-0.777 -17.688,-1.033 -6.572,-0.257 -12.524,0.196 -17.38,0.411 -4.856,0.216 -8.617,0.195 -13.18,0.08 -4.563,-0.115 -9.928,-0.325 -13.454,-1.605 -2.368,-0.859 -3.907,-2.201 -5.093,-3.769 -0.58,-0.767 -1.077,-1.588 -1.544,-2.433 -1.421,-2.573 -2.575,-5.366 -3.182,-8.496 -0.607,-3.129 -0.667,-6.595 -0.699,-9.6 -0.032,-3.005 -0.036,-5.551 0.625,-8.191z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
